module.exports = __webpack_public_path__ + "static/media/3.5d959ac7.jpg";